import React, { ReactComponentElement } from 'react';
import { ReactComponent as Apple } from '../../../../media/apple.svg';
import styles from './Carer.module.css';

const CarerTypeDeactivatedView = (): ReactComponentElement<any> => {
  return (
    <>
      {/*
        Kry rebrand note: this should probably be localised
        also: I don't think we have access to this email address 
      */}
      <div className={styles.carerUnavailableContainer}>
        <Apple></Apple>
        <div className={styles.carerUnavailableTextContainer}>
          <label className={styles.carerUnavailableTextTitle}>
            ACPs not enabled
          </label>
          <label className={styles.carerDeactivatedTextBody}>
            Contact livi.service@nhs.net if you wish to enable ACPs in your
            service
          </label>
        </div>
      </div>
    </>
  );
};

export default CarerTypeDeactivatedView;
